//ACTION
export const SET_PRODUCT_INPUTS = 'SET_PRODUCT_INPUTS';
export const RESET_PRODUCT = 'RESET_PRODUCT';

